import {QWebChannel} from '../../assets/qwebchannel';
import {MessagesService} from '../services/messages.service';
import {MSG_TYPE} from '../enum/message.enum';

export class HscWebsocket {
  // 拍照数据（base64）
  baseUrl = 'ws://127.0.0.1:12345';
  socket: any;
  imageIndex: any;
  // 储存图片路径的变量和数组
  imgPath = '';
  imgPathArray: any[] = [];
  s_fileBase64 = '';
  dialog: any;
  devSelect = [];
  priSelect = [];

  constructor(
    private messagesService: MessagesService,
  ) {
  }

  openSocket() {
    this.socket = new WebSocket(this.baseUrl);
    this.socket.onclose = () => {
      console.error('web channel closed');
    };
    this.socket.onerror = (error) => {
      console.error('web channel error: ' + error);
      this.messagesService.sendMessage({name: MSG_TYPE.WEBSOCKET_CONNECT_ERROR});
    };
    const cur = this;
    this.socket.onopen = () => {
      // console.log('WebSocket start connect');
      const qWebChannel = new QWebChannel(cur.socket, (channel) => {
        cur.dialog = channel.objects.dialog;

        window.onbeforeunload = () => {
          // 发送关闭信号
          cur.dialog.get_actionType('closeSignal');
          // 关闭socket
          cur.socket.close();
        };
        window.onunload = () => {
          // 发送关闭信号
          cur.dialog.get_actionType('closeSignal');
          // 关闭socket
          cur.socket.close();
        };

        document.getElementById('devList').onchange = () => {
          // 清除展示信息
          const resolutionList = document.getElementById('resolutionList') as any;
          resolutionList.options.length = 0;
          const modelList = document.getElementById('modelList') as any;
          modelList.options.length = 0;
          const select = document.getElementById('devList') as any;
          cur.dialog.devChanged('primaryDev_:' + select.value);
        };
        // 模式列表点击
        document.getElementById('modelList').onchange = () => {
          // 清除展示信息
          const resolutionList = document.getElementById('resolutionList') as any;
          resolutionList.options.length = 0;
          const select = document.getElementById('modelList') as any;
          cur.dialog.devChanged('primaryDev_:' + select.value);
        };

        // 分辨率列表点击
        document.getElementById('resolutionList').onchange = () => {
          // 清除展示信息
          const select = document.getElementById('resolutionList') as any;
          cur.dialog.devChanged('primaryDev_:' + select.value);
        };

        cur.dialog.sendPrintInfo.connect(message => {
          // 获取文件base64返回值
          if (message.indexOf('fileBase64:') >= 0) {
            const value = message.substr(11);
            alert(value);
            return;
          }

          // 设备信息 priModel
          if (message.indexOf('priDevName:') >= 0) {
            message = message.substr(11);
            const select = document.getElementById('devList') as any;
            if (message.indexOf('USB') >= 0) {
              select.add(new Option(message));
              this.devSelect.push(message);
            } else {
              select.add(new Option(message), 0);
              this.devSelect.unshift(message);
            }
            select.selectedIndex = 0;
          }
          // 设备出图格式
          if (message.indexOf('priModel:') >= 0) {
            message = message.substr(9);
            const select = document.getElementById('modelList') as any;
            if (message.indexOf('MJPG') >= 0) {
              select.add(new Option(message), 0);
            } else {
              select.add(new Option(message));
            }
            select.selectedIndex = 0;
          }
          // 设备分辨率
          if (message.indexOf('priResolution:') >= 0) {
            message = message.substr(14);
            const select = document.getElementById('resolutionList') as any;
            select.add(new Option(message));
            if (select.options.length > 1) {
              select.selectedIndex = 1;
            }
          }
          // 图片保存后返回路径关键字savePhoto_success:
          else if (message.indexOf('savePhoto_success:') >= 0) {
            this.imgPath = message.substr(18);
            this.addImgDiv();
          }
          // 合成pdf成功，返回路径关键字composePDF_success:
          else if (message.indexOf('composePDF_success:') >= 0) {
            const path = message.substr(19);
            this.removeAll();
            alert(path);
          }

        });
        // 接收图片流用来展示，多个，较小的base64数据
        cur.dialog.send_priImgData.connect(message => {
          const element = document.getElementById('bigPriDev') as any;
          element.src = 'data:image/jpg;base64,' + message;
        });
        // 接收拍照base64
        cur.dialog.send_priPhotoData.connect(message => {
          // const element = document.getElementById('devPhoto') as any;
          // element.src = 'data:image/jpg;base64,' + message;
          this.imgPath = 'data:image/jpg;base64,' + message;
          this.addImgDiv();
        });
        // 网页加载完成信号
        cur.dialog.html_loaded('one');
      });
    };
  }

  closeSocket() {
    // 发送关闭信号
    if (this.dialog) {
      this.dialog.get_actionType('closeSignal');
    }
    // 关闭socket
    this.socket.close();
  }

  getPhoto() {
    // 拍照返回base64
    this.dialog.photoBtnClicked('primaryDev_');
    // 拍照保存到本地，如果不需要保存到本地则可以注释
    // this.dialog.get_actionType('savePhotoPriDev');
  }

  turnLeft() {
    this.dialog.get_actionType('rotateLeft');
  }

  turnRight() {
    this.dialog.get_actionType('rotateRight');
  }

  // 纠偏裁边
  setDeskew() {
    this.dialog.get_actionType('setdeskew');
  }

  // 取消纠偏裁边
  unSetDeskew() {
    this.dialog.get_actionType('setdeskewOff');
  }

  useMainCamera() {
    this.dialog.devChanged('primaryDev_:' + this.devSelect[0]);
    const resolutionList = document.getElementById('resolutionList') as any;
    resolutionList.options.length = 0;
    const modelList = document.getElementById('modelList') as any;
    modelList.options.length = 0;
    // const select = document.getElementById('devList') as any;
    // select.value = this.devSelect[0];
    this.dialog.devChanged('primaryDev_:' + this.devSelect[0]);
  }

  useSubCamera() {
    this.dialog.devChanged('primaryDev_:' + this.devSelect[1]);
    const resolutionList = document.getElementById('resolutionList') as any;
    resolutionList.options.length = 0;
    const modelList = document.getElementById('modelList') as any;
    modelList.options.length = 0;
    // const select = document.getElementById('devList') as any;
    // select.value = this.devSelect[1];
    this.dialog.devChanged('primaryDev_:' + this.devSelect[1]);
  }

  // 预览图片
  openImage(imageItem) {
    const url = imageItem.parentNode.id;
    const top = screen.availHeight - 500;
    const left = screen.availWidth - 170;
    window.open('./new.html', 'newwindow', 'height=500, width=770, top=' + top + ', left=' + left + ', toolbar=no, menubar=no, scrollbars=yes,resizable=no,location=no, status=no');
  }

  // 增加图片缩略图
  addImgDiv() {
    // const container = document.getElementById('container');
    // const newchild = document.createElement('div');
    // newchild.setAttribute('style', 'float:left');
    // this.imgPath = 'file:///' + this.imgPath;
    // newchild.setAttribute('id', this.imgPath);
    // this.imgPathArray.push(this.imgPath); // 增加缩略图时默认把路径加入图片数组
    this.imgPathArray.push({
      src: this.imgPath,
      name: String(new Date().getTime()) + '.jpg',
      fileType: null,
    });
    // newchild.innerHTML = '<img width=\'105\' height=\'85\' src=\'' + this.imgPath + '\' onclick=\'openImage(this)\' /></img><input type=\'checkbox\' checked=\'checked\' onchange=\'checkboxClicked(this)\' />';
    // container.appendChild(newchild);
  }

  // 清空缩略图
  removeAll() {
    // document.getElementById('container').innerHTML = '';
    this.imgPathArray = [];
  }

  // 处理缩略图CheckBox点击事件
  checkboxClicked(checkboxItem) {
    if (this.imgPathArray.indexOf(checkboxItem.parentNode.id) < 0) {
      this.imgPathArray.push(checkboxItem.parentNode.id);

    } else {
      const index = this.imgPathArray.indexOf(checkboxItem.parentNode.id);
      this.imgPathArray.splice(index, 1);
    }
  }

  // 清空本地文件
  // deleteFiles() {
  //   // tslint:disable-next-line:prefer-for-of
  //   for (let i = 0; i < this.imgPathArray.length; i++) {
  //     // 删除文件，第2个参数：图片文件路径，第3，第4个参数为空
  //     const path = this.imgPathArray[i];
  //     this.dialog.get_functionTypes('deleteFile', path, '', '');
  //   }
  //   this.removeAll();
  // }

  deleteFiles() {
    this.removeAll();
  }

  deleteFile(index) {
    this.imgPathArray.splice(index, 1);
  }
}
